import React, { useEffect, useState } from 'react'
import Meta from './layout/Meta'
import '../css/client.css';
import { Link } from 'react-router-dom';
import helpers from '../helper';
import axios from 'axios';
import ContentLoader from 'react-content-loader';
export default function Client() {
    const [clients, setClient] = useState([]);
    const [pageloader, setPageloader] = useState(false);
    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/clients')
                .then((response) => {
                    setClient(response.data.result.data);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setClient]);

    return (
        <>
            <Meta id={4} />
            <main className='Sec5'>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Clients" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Clients</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Clients</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="SliderBox">
                    <div className="container">
                        {
                            pageloader ?
                                <ContentLoader height={330} width={1660} backgroundColor="#f5f5f5"
                                foregroundColor="#dbdbdb">                                    
                                    <rect x="30" y="20" rx="8" width="200" height="100" />
                                    <rect x="250" y="20" rx="8" width="200" height="100" />
                                    <rect x="470" y="20" rx="8" width="200" height="100" />
                                    <rect x="690" y="20" rx="8" width="200" height="100" />
                                    <rect x="910" y="20" rx="8" width="200" height="100" />
                                    <rect x="30" y="150" rx="8" width="200" height="100" />
                                    <rect x="250" y="150" rx="8" width="200" height="100" />
                                    <rect x="470" y="150" rx="8" width="200" height="100" />
                                    <rect x="690" y="150" rx="8" width="200" height="100" />
                                    <rect x="910" y="150" rx="8" width="200" height="100" />
                                </ContentLoader>
                                :
                                <>
                                    {
                                        clients.length > 0 ?
                                            <div className="row text-center">
                                                {
                                                    clients.map((client, cl) =>
                                                        <div key={cl} className="col-xl-2 col-md-3 lg-sm-4 col-6 Client mb-2">
                                                            {
                                                                helpers.helpers1(client.image) ?
                                                                    <picture className="img">
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/clients/' + client.image} alt={client.title} className="w-100" width="150" height="100" />
                                                                    </picture>
                                                                    :
                                                                    <picture className="img">
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/clients/webp/' + client.image + '.webp'} type="image/webp" />
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/clients/avif/' + client.image + '.avif'} type="image/avif" />
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/clients/jpg/' + client.image + '.jpg'} alt={client.title} className="w-100" width="150" height="100" />
                                                                    </picture>
                                                            }
                                                            <small>{client.title}</small>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                            :
                                            ''
                                    }
                                </>

                        }

                    </div>
                </section>
            </main>
        </>
    )
}
